
import { mapActions, mapState } from 'pinia';
import { defineComponent } from 'vue';
import { useStore } from '@/plugins/store';
import CustomSelect from '@/components/ui/CustomSelect.vue';
import CustomCheckbox from '@/components/ui/CustomCheckbox.vue';
import Popover from '@/components/ui/Popover.vue';

export default defineComponent({
    components: { CustomSelect, CustomCheckbox, Popover },
    data() {
        return {
            chosenApplyDataSource: null as boolean | null,
            chosenDataSource: null as { id: string; text: string } | null,
            dataSources: [
                {
                    id: 'prod',
                    text: 'Production',
                },
                {
                    id: 'dev',
                    text: 'Development',
                },
            ],
        };
    },
    computed: {
        ...mapState(useStore, ['dataSource', 'applyDataCutoff']),
        selectLabel(): string {
            return this.dataSources.find((dataSource) => dataSource.id === this.dataSource)?.text || '';
        },
    },
    watch: {
        dataSource: {
            handler() {
                this.chosenDataSource = this.dataSources.find((dataSource) => dataSource.id === this.dataSource)!;
            },
            immediate: true,
        },
        applyDataCutoff: {
            handler() {
                this.chosenApplyDataSource = this.applyDataCutoff;
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions(useStore, ['getDataSource', 'setDataSource', 'getApplyDataCutoff', 'setApplyDataCutoff']),
        async onSaveClicked() {
            console.log('this.chosenApplyDataSource', this.chosenApplyDataSource);
            if (this.chosenApplyDataSource !== null && this.chosenDataSource !== null) {
                await this.setApplyDataCutoff(this.chosenApplyDataSource);
                await this.setDataSource(this.chosenDataSource.id);
                window.location.reload();
            }
            if (this.chosenApplyDataSource !== null) {
                await this.setApplyDataCutoff(this.chosenApplyDataSource);
                window.location.reload();
            }
            if (this.chosenDataSource !== null) {
                await this.setDataSource(this.chosenDataSource.id);
                window.location.reload();
            }
        },
    },
    created() {
        this.getDataSource();
        this.getApplyDataCutoff();
    },
});
